export const blockIconsNotificationMore = (
	<span className='material-symbols-outlined'>more</span>
);
